import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../../components/isLoading";
import JobsTableContainer from "../TableContainer";
import moment from "moment";
import formatJobs from "../../../helpers/formatBlog";
import { fetchJobsData } from "../../../redux/jobs/index";
import { Button } from "@mui/material";
import { NavLink } from "react-router-dom";

export default () => {
	const jobsData = useSelector((state) => state.jobsGlobalStore);

	const dispatch = useDispatch();

	const [dataState, setDataState] = useState({
		formattedJobsData: [],
		authorRecords: [],
		currentPage: 0,
	});

	useEffect(() => {
		dispatch(fetchJobsData(dataState.currentPage));
	}, [dataState.currentPage]);

	let formattedJobsData = [];

	useEffect(() => {
		for (const job of jobsData.data?.data || []) {
			const formattedData = formatJobs(job);
			formattedData.updated = moment(job.deadline).format("ll");
			formattedJobsData.push(formattedData);
		}

		setDataState((prevState) => ({
			...prevState,
			formattedJobsData,
			currentPage: jobsData.data.pagination?.offset || 0,
		}));
	}, [jobsData.data]);

	const onPageChange = (pageNumber) =>
		setDataState((prevState) => ({ ...prevState, currentPage: pageNumber }));

	return (
		<div>
			{jobsData.loading && !jobsData.data.data ? (
				<Loading />
			) : (
				<>
					<div
						style={{
							padding: "15px",
							float: "right",
						}}
					>
						<Button
							variant="outlined"
							component={NavLink}
							to="/jobs/new"
							sx={{
								color: "#E00186",
								border: "1px solid #E00186",
								fontFamily: "Arial",
								"&:hover": {
									color: "#fff",
									backgroundColor: "#E00186",
									border: "1px solid #E00186",
								},
							}}
						>
							Add new Job
						</Button>
					</div>
					<JobsTableContainer
						headCells={[
							{ id: "title", rightAlign: false, label: "Title" },
							{ id: "status", rightAlign: true, label: "Status" },
							{ id: "deadline", rightAlign: true, label: "Deadline" },
						]}
						isUpdating={jobsData.loading && jobsData.data.data[0]}
						formattedData={dataState.formattedJobsData}
						hidden={["postDate", "author"]}
						title="All Jobs"
						pagination={jobsData.data.pagination || {}}
						onPageChange={onPageChange}
						noAvatar
					/>
				</>
			)}
		</div>
	);
};
